import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import SelectableButton from '../ui/buttons/SelectableButton';
import { MAX_PRIORITY_FUNCTIONS, ANALYTICS } from 'consts';
import classNames from 'classnames';
import AnalyticsContext from './analytics/AnalyticsContext';
import Options from '../shared/SelectableOptions';

class TalentSuperheroFunctions extends React.Component {
  static ShowMore({ handleClick }) {
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
    const { trackEvents } = useContext(AnalyticsContext);
    return (
      <div className="col mt-2">
        <SelectableButton
          data-id="show-more-superhero-btn"
          selected={false}
          action={() => {
            handleClick();
            trackEvents(ANALYTICS.EVENT_TYPES.Click)({
              target: 'Show More Superpowers',
            });
          }}
          label="Show More..."
        />
      </div>
    );
  }
  constructor(props) {
    super(props);
    this.functionsOther = props.options.filter(item => {
      if (item.priority > MAX_PRIORITY_FUNCTIONS) {
        return item;
      }
    });
    this.state = {
      showOther: false,
    };
  }

  render() {
    const props = this.props;
    const functionsClasses = classNames('form-group col-12 questionnaire', {
      validate: props.validate,
    });
    return (
      <div className="row">
        <div className={functionsClasses}>
          <div className="font-md font-medium" id="superpower-label">
            {props.label}
            {props.validate && <span className="required-mark">*</span>}{' '}
          </div>
          {props.helpText ? (
            <div className="text-alt font-sm mt-1 mb-3">{props.helpText}</div>
          ) : (
            <div className="text-alt font-sm mb-3" />
          )}
          <Options
            featured
            targetName="Superpower"
            options={this.getFeaturedOptions(
              props.options,
              MAX_PRIORITY_FUNCTIONS,
            )}
            cols={props.cols}
            selected={props.selected}
            handleClick={this.handleClick}
          />
          {this.state.showOther ||
          this.functionInCollapsedOptions(this.props.selected) ? (
            <Options
              targetName="Superpower"
              options={this.getOtherOptions(
                props.options,
                MAX_PRIORITY_FUNCTIONS,
              )}
              cols={props.cols}
              selected={props.selected}
              handleClick={this.handleClick}
            />
          ) : (
            <TalentSuperheroFunctions.ShowMore
              handleClick={this.handleClickShowMore}
            />
          )}
        </div>
      </div>
    );
  }

  getOtherOptions(options, max) {
    return options.filter(item => item.priority > max);
  }

  getFeaturedOptions(options, max) {
    return options.filter(item => !item.priority || item.priority <= max);
  }

  handleClick = action => {
    this.props.onChange(this.props.stateKey, action.id, this.props.maxLength);
  };

  handleClickShowMore = () => {
    this.setState({ showOther: !this.state.showOther });
  };

  // TODO - Fix this
  functionInCollapsedOptions = selectedFunction => {
    let isInCollapsedOptions = false;
    this.functionsOther.map(item => {
      if (item.id === selectedFunction) {
        isInCollapsedOptions = true;
      }
    });
    return isInCollapsedOptions;
  };
}

TalentSuperheroFunctions.propTypes = {
  options: PropTypes.array.isRequired,
  cols: PropTypes.number.isRequired,
  helpText: PropTypes.string,
  selected: PropTypes.any,
  fieldName: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  stateKey: PropTypes.string.isRequired,
  validate: PropTypes.bool,
  label: PropTypes.string,
};

TalentSuperheroFunctions.defaultProps = {
  validate: false,
};

export default TalentSuperheroFunctions;
